import Vue from 'vue'
import Router from 'vue-router'
import Dashboard from '@/components/Dashboard/Dashboard'
import Status404 from '@/components/ResponseCodes/Status404'
import Status403 from '@/components/ResponseCodes/Status403'
import Main from '@/components/main/main'
import Login from '@/components/login/login'
import DirectLogin from '@/components/login/DirectLogin'
import UserUtil from './../util/UserUtil'
import RouteUtil from './../util/RouteUtil'
import store from './../store/store'
import { CustomizationLoader } from 'CustomModules/loader'
import GrupoTipos from '@/components/GrupoTipos/GrupoTipos'

import HttpUtil from '../util/HttpUtil'
import JsUtils from '../util/JsUtils'

Vue.use(Router)

/* es posible que algun compoente quiera sobre escribir el componente main o login o cualquier otro del core */
let mainComponent = Main
let loginComponent = Login

/* carga las rutas de los plugins */
const pluginRoutes = []
/* carga las rutas globales de los plugins - Son rutas del mismo nivel del main. */
const globalPluginRoutes = []
/* cargoa las rutas publicas a las que se puede acceder sin necesidad de iniciar sesion */
const publicRoutes = []
/* Se */
CustomizationLoader.paths.forEach((path) => {
  let settings = require(`CustomModules/${path}/routes`)
  pluginRoutes.push(...settings.Routes)

  if (settings.GlobalRoutes && settings.GlobalRoutes.length > 0) {
    globalPluginRoutes.push(...settings.GlobalRoutes)
  }

  if (settings.PublicRoutes && settings.PublicRoutes.length > 0) {
    publicRoutes.push(...settings.PublicRoutes)
  }

  if (!JsUtils.isEmpty(settings.Override)) {
    if (!JsUtils.isEmpty(settings.Override.mainComponent)) {
      mainComponent = settings.Override.mainComponent
    }
    if (!JsUtils.isEmpty(settings.Override.loginComponent)) {
      loginComponent = settings.Override.loginComponent
    }
  }
})

const router = new Router({
  routes: [
    ...globalPluginRoutes,
    {
      path: '/bklg/:expires_in/:access_token',
      name: 'BKLG',
      component: DirectLogin
    },
    {
      path: '/login',
      name: 'Login',
      component: loginComponent
    },
    {
      path: '/',
      component: mainComponent,
      children: [
        ...pluginRoutes,
        {
          path: '/',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: '404',
          name: '404',
          component: Status404
        },
        {
          path: '403',
          name: '403',
          component: Status403
        },
        {
          path: 'grupotipos',
          name: 'GrupoTipos',
          component: GrupoTipos
        },
        {
          path: '*',
          redirect: '/404'
        }
      ]
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

router.beforeEach((to, from, next) => {
  let token = Vue.ls.get('token', null)
  if (token === null) {
    if (to.name === 'Login' || to.name === 'BKLG' || publicRoutes.includes(to.name)) {
      store.commit('setLastRoute', null)
      next()
    } else {
      store.commit('setLastRoute', to)
      next({
        name: 'Login'
      })
    }
  } else {
    UserUtil.loadUserInfo((response) => {
      if (to.name === 'Login') {
        next({
          name: response.menu[0].name
        })
      } else if (RouteUtil.canEnter(response, to)) {
        next()
      } else {
        next({
          name: '403'
        })
      }
    }, (response) => {
      if (typeof response.response === 'undefined') {
        next(to)
      } else if (response.response.status === 401) {
        Vue.ls.remove('token')
        HttpUtil.clearhttp()
        next({
          name: 'Login'
        })
      }
    })
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js